import {
  Box,
  Container,
  Paper,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemIcon,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";

import { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../../Components/Header";
import ArticleIcon from "@mui/icons-material/Article";
import Footer from "../../../Components/Footer";
import GavelIcon from "@mui/icons-material/Gavel";
import { useSelector } from "react-redux";

const TermsAndConditions = () => {
  const [termsData, setTermsData] = useState({});
  const language = useSelector((state) => state.language.language)

  const getTerms = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}getTerms`
      );
        console.log(response)
      if (response.status === 200 && response.data.length > 0) {
        setTermsData(response?.data?.[0]?.terms[0])
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTerms();
  }, []);

  console.log(termsData)

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f7f7f7", // Light gray background to balance vibrant yellow and teal
          minHeight: "100vh",
          py: 6,
          fontFamily: '"Roboto", sans-serif', // Set Roboto as the font family globally
        }}
      >
        <Container maxWidth="lg">
          {/* Header Section */}
          <Paper
            elevation={3}
            sx={{
              backgroundColor: "#fff",
              padding: 4,
              borderRadius: 4,
              mb: 5,
              position: "sticky",
              top: 0,
              zIndex: 1,
              boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)",
              border: "2px solid #E0E0E0",
            }}
          >
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
              gap="20px"
            >
              <GavelIcon sx={{ color: "#27BAC4", fontSize: "32px" }} />

              <Typography
                variant="h5"
                component="h1"
                align="center"
                sx={{
                  fontWeight: 700,
                  letterSpacing: 1,
                }}
              >
                {"  "}
                Terms and Conditions
              </Typography>
            </Box>
          </Paper>

          {/* Content Section */}
          <Paper
            elevation={2}
            sx={{
              padding: 5,
              borderRadius: 4,
              boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.08)",
              border: "2px solid #E0E0E0",
            }}
          >
            {termsData?.[language]?.map((term, index) => (
              <Box sx={{ mb: 5 }}>
                <Typography
                  variant="h5"
                  sx={{
                    mb: 3,
                    fontWeight: 600,
                  }}
                >
                  {term?.title}
                </Typography>
                <List>
                  <ListItem sx={{ display: "flex", alignItems: "flex-start" }}>
                    <ListItemIcon>
                      {/* Blue check-circle icon */}
                      <CheckCircle
                        color="#27BAC4" // Teal for the main title
                        sx={{ color: "#27BAC4 ", fontSize: 22 }}
                      />{" "}
                    </ListItemIcon>
                    <Typography
                      variant="body1"
                      sx={{ lineHeight: 1.7 }}
                      dangerouslySetInnerHTML={{ __html: term?.description }}
                    />
                  </ListItem>
                </List>
                {index !== termsData?.length - 1 && <Divider sx={{ mb: 4 }} />}
              </Box>
            ))}
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default TermsAndConditions;
